export default "__VITE_ASSET__DwCoqOqO__"